export default __webpack_public_path__ + "static/media/2_en.a877e689.png";